<template>
	<div class="container">
		<!-- <div class="overlay" :class="{ 'showOverlay': show }" @click="close">
        </div>
		<div class="detail" :class="{ 'showOverlay': show }">
			<shopCardDialog :store="store" v-if="store.store_name"></shopCardDialog>
		</div> -->
		<storedetail-tip :store="store" v-if="store.store_name"></storedetail-tip>
		<storedetail-header :store="store"></storedetail-header>
		<div class="tab-wrapper">
			<storedetail-tab :tabs="tabs" v-if="store.store_name"></storedetail-tab>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getStoreInfo } from "../../../api/homestoredetail";
import StoredetailHeader from "./StoredetailHeader";
import StoredetailTab from "./StoredetailTab";
import StoredetailTabGoods from "./StoredetailTabGoods";
import StoredetailTabRatings from "./StoredetailTabRatings";
import StoredetailTabInfo from "./StoredetailTabInfo";
import StoredetailTip from "./StoredetailTip";
// import shopCardDialog from "./common/shop-cart-dialog.vue";
import { flowstat_record } from '../../../api/homestoredetail';
export default {
	name: "Storedetail",
	data() {
		return {
			store: {
				store_id: this.$route.query.id ? this.$route.query.id : "",
			},
		};
	},
	computed: {
		...mapState({
			token: (state) => state.member.token,
			member_point: state => state.member.point,
			// show: state => state.goodsdetail.showDetail,
		}),
		tabs() {
			return [
				{
					label: this.$t('store.tabs.goods'),
					component: StoredetailTabGoods,
					data: {
						store: this.store,
					},
				},
				{
					label: this.$t('store.tabs.about'),
					component: StoredetailTabRatings,
					data: {
						store: this.store,
					},
				},
				{
					label: this.$t('store.tabs.info'),
					component: StoredetailTabInfo,
					data: {
						store: this.store,
					},
				},
			];
		},
	},
	created() {
		this._getStoreInfo();
		flowstat_record(this.store.store_id,'','Store')
			.then((res) => {
				console.log('flowstat_record')
			})
			.catch(() => {
				console.log('rejected');
			})
	},
	methods: {
		...mapActions([
			'setStoreInfo',
			// 'setDetail'
		]),
		_getStoreInfo() {
			getStoreInfo(
				this.store.store_id, 
				this.token,
				this.member_point.lng,
        		this.member_point.lat,
			)
				.then((res) => {
					this.store = res.result.store_info;
					this.setStoreInfo(this.store)
				})
				.catch(function (error) {});
		},
		// close() {
		// 	this.setDetail(false)
		// }
	},
	components: {
		StoredetailHeader,
		StoredetailTab,
		StoredetailTip,
		// shopCardDialog
	},
};
</script>

<style scoped>
.tab-wrapper {
	position: fixed;
	top: 8rem;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>

<style scoped>
/* .overlay {
	position: fixed;
	display: none;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 2;
	cursor: pointer;
}
.detail {
	z-index: 3;
	height: 80vh;
	display: none;
	bottom: 0;
	background: white;
	border-top-right-radius: 35px;
	left: 0px;
	position: absolute;
	right: 0;
	border-top-left-radius: 35px;
	padding: 30px;
	overflow: scroll;
}
.showOverlay {
	display: block;
} */
</style>
